export const SET_BOM_DETAILS = "SET_BOM_DETAILS";
export const SET_BOM_PRODUCTION_PROCESS = "SET_BOM_PRODUCTION_PROCESS";
export const SET_BOM_FINISHED_GOOD_ITEMS = "SET_BOM_FINISHED_GOOD_ITEMS";
export const SET_BOM_RAW_MATERIAL_ITEMS = "SET_BOM_RAW_MATERIAL_ITEMS";
export const SET_BOM_SCRAP_LOG_ITEMS = "SET_BOM_SCRAP_LOG_ITEMS";
export const SET_BOM_CHARGES = "SET_BOM_CHARGES";
export const SET_EDIT_BOM_DATA = "SET_EDIT_BOM_DATA";
export const SET_BOM_DATA = "SET_BOM_DATA";

export const RESET_BILL_OF_MATERIAL = "RESET_BILL_OF_MATERIAL";